import httpClient from '@/libs/http-client'

export function bettingList (params) {
  const url = '/api/bet/betlistNew'
  return httpClient.post(url, params).then(response => {
    return response
  })
}
